export const dedupeNodes = (items) => {
  const seen = new Set();
  return items.filter((el) => {
    const duplicate = seen.has(el.node.id);
    seen.add(el.node.id);
    return !duplicate;
  });
};

export const isIterable = (items) => {
  return Symbol.iterator in Object(items);
};

export const extractNodes = (edges = []) => {
  let data = [];
  edges.forEach((edge) => {
    data.push(edge.node);
  });
  return data;
};
